export const CALENDLY_URL_PARAM = "result_url";
export const CALENDLY_IFRAME_FALLBACK_TIMEOUT_MS = 4500;
export const THANKS_CONFIRMED_URL = "https://www.doorloop.com/thanks-confirmed";
